import React from "react";
import { GraduationCap, PlayCircle } from "lucide-react";

const VIDEOS = [
  {
    id: "welcome",
    title: "Getting Started with AFHA",
    description: "Welcome to AFHA — an introduction to onboarding physicians and building your business.",
    src: "https://player.vimeo.com/video/1207441368?h=8195440f79",
  },
];

export default function Training() {
  return (
    <div data-testid="training-page">
      <div className="mb-8 flex items-center gap-3">
        <div className="h-11 w-11 rounded-lg bg-navy/5 flex items-center justify-center">
          <GraduationCap className="h-5 w-5 text-navy" />
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-patriot font-bold">Back Office</p>
          <h1 className="font-display text-3xl text-navy">Training</h1>
        </div>
      </div>

      <p className="text-muted-foreground mb-8 max-w-2xl">
        Watch these videos to learn how to succeed with AFHA — from onboarding your
        first physician to growing your organization.
      </p>

      <div className="grid grid-cols-1 gap-8">
        {VIDEOS.map((v) => (
          <div key={v.id} className="bg-white border border-border rounded-xl overflow-hidden" data-testid={`training-video-${v.id}`}>
            <div className="relative w-full bg-navy-deep" style={{ paddingTop: "56.25%" }}>
              <iframe
                title={v.title}
                src={v.src}
                className="absolute inset-0 h-full w-full"
                frameBorder="0"
                referrerPolicy="strict-origin-when-cross-origin"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                allowFullScreen
              />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-2">
                <PlayCircle className="h-5 w-5 text-patriot" />
                <h2 className="font-display text-xl text-navy">{v.title}</h2>
              </div>
              <p className="text-sm text-muted-foreground">{v.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
